import React from 'react';
import {
  LegalContainer,
  LegalHeader,
  LegalTitle,
  LegalContent,
} from '../shared/LegalStyles';
import { privacyContent } from '../../data/privacyContent';

const Privacy: React.FC = () => {
  return (
    <LegalContainer>
      <LegalHeader>
        <LegalTitle>Privacy Policy</LegalTitle>
      </LegalHeader>
      <LegalContent dangerouslySetInnerHTML={{ __html: privacyContent }} />
    </LegalContainer>
  );
};

export default Privacy;
